import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useImmer } from 'use-immer';
import axios from 'axios';

import PopupAgreement from './PopupAgreement';

const onRegisterSubmit = (d) => {
  d.setError(!1);

  let err = [];
  if (d.field.first_name.trim() === '') {
    err = [...err,'First name is required!'];
  }
  if (d.field.org.trim() === '') {
    err = [...err,'Institution/Organization/Company name is required!'];
  }
  if (d.field.org_type.trim() === '') {
    err = [...err,'Institution type is required!'];
  }
  if (d.field.country.trim() === '') {
    err = [...err,'Country of residence is required!'];
  }
  if (d.field.password.trim().length < 6) {
    err = [...err,'Minimum 6 chars for password!'];
  }

  if (d.field.email.trim() === '') {
    err = [...err,'Email address is required!'];
  } else {
    const e = d.field.email.trim();
    if (
      e.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
      )
    ) {
    } else {
      err = [...err,'Email address invalid!'];
    }
  }

  if (err.length) {
    d.setError(err);
    d.setLoader(!1);
  } else {
    d.setShowAgreement(1);
    document.querySelector('.popup-inner').scrollTop = 0;
  }
};

const onAgree = (d) => {
  d.setLoader(1);
  axios.post(
    '/register',
    d.field
  ).then((r) => {
    d.setShowAgreement(!1);
    d.setLoader(!1);
    if (r.data.status) {
      d.setSuccess({
        first_name: r.data.first_name,
        email: r.data.email
      });
    } else {
      d.setError([r.data.msg]);
    }
  });
};

const PopupRegister = ({ show }) => {
  const setApp = useDispatch();

  const [field, setField] = useImmer({
    email: '',
    password: '',
    first_name: '',
    last_name: '',
    org: '',
    org_type: '',
    country: ''
  });
  const [error, setError] = useState(!1);
  const [success, setSuccess] = useState(!1);
  const [loader, setLoader] = useState(!1);
  const [showAgreement, setShowAgreement] = useState(!1);

  if (!show) {
    return null;
  }

  return (
    <div
      className="popup-child"
      style={{
        display: `${show === 'Register' ? '' : 'none'}`,
        opacity: `${show ? 1 : 0}`
      }}
    >
      {
        showAgreement
          ? (
              <PopupAgreement
                show={showAgreement}
                onBack={() => {
                  setShowAgreement(!1);
                }}
                loader={loader}
                onAgree={() => {
                  onAgree({
                    field,
                    _csrf_token:window._csrf_token,
                    setError,
                    setSuccess,
                    setLoader,
                    setApp,
                    setShowAgreement,
                  })
                }}
              />
            )
          : (
              <form className="popup-child-text">
                {
                  success
                    ? (
                        <>
                          <div className="alert alert-success">
                            Email verification link sent!
                          </div>
                          <p>
                            <br/>
                            Thanks <b>{success.first_name}</b>!
                            <br/>
                            {'Please check your email ('}
                            <b>{success.email}</b>
                            {') inbox to get the verification link'}
                            <br/>
                            <small>
                              {'*Please check your spam folder if you haven\'t'}
                              {' received it in your inbox.'}
                            </small>{}
                            <br/><br/>_<br/>
                            WILDMEAT Team
                            <br/><br/>
                          </p>
                        </>
                      )
                    : (
                        <>
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label htmlFor="first_name">
                                  <b style={{
                                    fontWeight:500,
                                    color:'#836f35'
                                  }}>
                                    First name
                                  </b>
                                </label>
                                <input
                                  value={field.first_name}
                                  onChange={(e) => {
                                    setField(d => {
                                      d.first_name = e.target.value;
                                    });
                                  }}
                                  placeholder="Enter first name..."
                                  type="text"
                                  className="form-control"
                                  id="first_name"
                                  required
                                  autoFocus
                                />
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label htmlFor="last_name">
                                  <b style={{
                                    fontWeight:500,
                                    color:'#836f35'
                                  }}>
                                    Last name
                                  </b>
                                </label>
                                <input
                                  value={field.last_name}
                                  onChange={(e)=>{
                                    setField(d => {
                                      d.last_name = e.target.value;
                                    });
                                  }}
                                  placeholder="Enter last name..."
                                  type="text"
                                  className="form-control"
                                  id="last_name"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <label htmlFor="affiliation">
                              <b style={{
                                fontWeight:500,
                                color:'#836f35'
                              }}>
                                Institution/Organization/Company name
                              </b>
                            </label>
                            <input
                              value={field.org}
                              onChange={(e)=>{
                                setField(d => {
                                  d.org = e.target.value;
                                });
                              }}
                              placeholder={[
                                'Enter Institution/Organization/Company name...'
                              ].join('')}
                              type="text"
                              className="form-control"
                              id="affiliation"
                              required
                            />
                          </div>

                          <div className="form-group">
                            <label htmlFor="role">
                              <b style={{
                                fontWeight:500,
                                color:'#836f35'
                              }}>
                                Institution type
                              </b>
                            </label>
                            <select
                              className="form-control"
                              value={field.org_type}
                              onChange={(e)=>{
                                setField(d => {
                                  d.org_type = e.target.value;
                                });
                              }}
                              required
                            >
                              <option value=''>Choose...</option>
                              <option value='Government'>Government</option>
                              <option value='Education'>Education</option>
                              <option value='Non profit'>Non profit</option>
                              <option value='Media'>Media</option>
                              <option value='Research'>Research</option>
                              <option value='Commercial'>Commercial</option>
                              <option value='Other'>Other</option>
                            </select>
                          </div>

                          <div className="form-group">
                            <label htmlFor="role">
                              <b style={{
                                fontWeight:500,
                                color:'#836f35'
                              }}>
                                Country of residence
                              </b>
                            </label>
                            <select
                              className="form-control"
                              value={field.country}
                              onChange={(e)=>{
                                setField(d => {
                                  d.country = e.target.value;
                                });
                              }}
                              required
                            >
                              <option value=''>Choose...</option>
                              {
                                window.countries?.map(country => (
                                  <option key={country} value={country}>
                                    {country}
                                  </option>
                                ))
                              }
                            </select>
                          </div>

                          <div className="form-group">
                            <label htmlFor="reg-email">
                              <b style={{
                                fontWeight:500,
                                color:'#836f35'
                              }}>
                                Email address
                              </b>
                            </label>
                            <input
                              value={field.email}
                              onChange={(e)=>{
                                setField(d => {
                                  d.email = e.target.value;
                                });
                              }}
                              placeholder="Enter email address..."
                              type="email"
                              className="form-control"
                              id="reg-email"
                              required
                              autoComplete="email"
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="reg-password">
                              <b style={{
                                fontWeight:500,
                                color:'#836f35'
                              }}>
                                Password
                              </b>
                            </label>
                            <input
                              value={field.password}
                              onChange={(e) => {
                                setField(d => {
                                  d.password = e.target.value;
                                });
                              }}
                              placeholder="Enter password..."
                              type="password"
                              className="form-control"
                              id="reg-password"
                              required
                              autoComplete="new-password"
                            />
                          </div>
                          <br/>
                          {
                            error && (
                              <div className="alert alert-warning">
                                {
                                  error.map((d, i) => (
                                    <span key={`${d}${i}`}>
                                      {i > 0 ? <br/> :''}{d}
                                    </span>
                                  ))
                                }
                              </div>
                            )
                          }
                          {
                            loader
                              ? <div className="lds-dual-ring2"></div>
                              : (
                                  <button
                                    type="submit"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setError(!1);
                                      onRegisterSubmit({
                                        field,
                                        _csrf_token:window._csrf_token,
                                        setError,
                                        setSuccess,
                                        setLoader,
                                        setApp,
                                        setShowAgreement,
                                      });
                                    }}
                                    className="btn btn-primary"
                                  >
                                    Sign Up
                                  </button>
                                )
                          }
                        </>
                      )
                }
              </form>
            )
        }
    </div>
  );
};

export default PopupRegister;
